import css from './index.module.scss';
import { useLang } from '@/app/utils/useLang';

export default function Content() {
    const { t } = useLang('theProduct');
    const list = [
        {
            className: 'qrcode',
            text: t.rich('qrcode', {
                a: (v: string) => <a href={v}>{v}</a>,
            }),
            imgs: ['https://websiteoss.ecoflow.com/upload/image/1769065725411/qrcode.png'],
        },
        {
            text: t('text1'),
            imgs: ['https://websiteoss.ecoflow.com/upload/image/1769065726272/1.png'],
        },
        {
            text: t('text2'),
            imgs: ['https://websiteoss.ecoflow.com/upload/image/1769065725231/2.png'],
        },
        {
            text: t('text3'),
            imgs: ['https://websiteoss.ecoflow.com/upload/image/1769065725031/3.png'],
        },
        {
            text: t('text4'),
            imgs: ['https://websiteoss.ecoflow.com/upload/image/1769065726459/4.png'],
        },
        {
            text: t('text5'),
            imgs: ['https://websiteoss.ecoflow.com/upload/image/1769065726634/5.png'],
        },
        {
            text: t('text6'),
            imgs: ['https://websiteoss.ecoflow.com/upload/image/1769065726815/6-1.png', 'https://websiteoss.ecoflow.com/upload/image/1769065726046/6-2.png'],
        },
        {
            text: t('text7'),
            imgs: ['https://websiteoss.ecoflow.com/upload/image/1769065727015/7.png'],
        },
        {
            text: t('text8'),
            imgs: ['https://websiteoss.ecoflow.com/upload/image/1769065727189/8.png'],
        },
        {
            text: t('text9'),
            imgs: [
                'https://websiteoss.ecoflow.com/upload/image/1769065727373/9-1.png',
                'https://websiteoss.ecoflow.com/upload/image/1769065724859/9-2.png',
                'https://websiteoss.ecoflow.com/upload/image/1769065725630/9-3.png',
            ],
        },
        {
            text: t('text10'),
            imgs: ['https://websiteoss.ecoflow.com/upload/image/1769065725839/10.png'],
        },
    ];
    return (
        <section
            className={`${css.page} GtmModuleData-section`}
            id="riverpro-firmware-update-guide"
            data-section-id={'riverpro-firmware-update-guide'}
            data-section-title={t('title')}
        >
            <div className="SOP-title">{t('title')}</div>
            {list.map((i, idx) => (
                <div className={`module-content ${i.className}`} key={idx}>
                    <div className="module-text">{i.text}</div>
                    <div className="module-imgs">{i.imgs.map((j) => j && <img src={j} alt="" key={j} />)}</div>
                </div>
            ))}

            <div className="module-content">
                <div className="module-title">{t('service_title')}</div>
                <div className="module-text">{t('service_text1')}</div>
                <div className="module-text">{t('service_text2')}</div>
                <div className="module-subtitle">{t('service_text3')}</div>
                <ul>
                    <li className="module-text">
                        {t.rich('service_text4', {
                            // 邮件
                            e: (e: string) => <a href={`mailto:${e}`}>{e}</a>,
                        })}
                    </li>
                    <li className="module-text">{t('service_text5')}</li>
                </ul>
                <div className="module-text text-right">{t('service_text6')}</div>
            </div>
        </section>
    );
}
